import { BASE_API_URL, BASE_SECURE_ROUTE } from "src/constants/api";
import type { RootState } from "src/redux/store";
import { includesSuperAdminRoleGroup } from "src/utils/roles";

export const buildResourcePathForCurrentUser = (
    state: RootState,
    desiredResource: string,
    additionalQueryParams: Record<string, string> = {},
) => {
    const queryParams = new URLSearchParams(additionalQueryParams);
    const isSuperAdmin = includesSuperAdminRoleGroup(state.user.user?.roleGroupIds);
    if (!isSuperAdmin) {
        const resource = desiredResource.startsWith("/")
            ? desiredResource.substring(1)
            : desiredResource;
        const queryString = queryParams.size ? `?${queryParams.toString()}` : ``;
        return `${BASE_API_URL}/${BASE_SECURE_ROUTE}/staff/${resource}${queryString}`;
    }
    const accountPublicUuid = state.account?.account?.publicUuid;
    if (!accountPublicUuid) throw new Error("refusing to build path without accountPublicUuid");
    queryParams.append("accountPublicUuid", accountPublicUuid);
    const resource = desiredResource.startsWith("/")
        ? desiredResource.substring(1)
        : desiredResource;
    const queryString = queryParams.size ? `?${queryParams.toString()}` : ``;
    return `${BASE_API_URL}/${BASE_SECURE_ROUTE}/admin/${resource}${queryString}`;
};
